// NavbarMenu.jsx
import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const yearRange = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, i) => end - i);

const acuerdosITEYears = yearRange(2015, 2025);
const acuerdosINEYears = [2025, 2024, 2023, 2022, 2021, 2020, 2016, 2015];
const boletinesYears = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2017, 2016, 2015];
const monitoreosYears = yearRange(2015, 2025);

const NavbarMenu = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => setExpanded(false), [location]);
  const handleLinkClick = () => setExpanded(false);

  return (
    <>
      <Navbar expanded={expanded} expand="lg" className="sticky-top modern-navbar">
        <Container>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className="border-0"
          />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
            <Nav className="mx-auto">

              {/* Acerca de ITE */}
              <NavDropdown title="Acerca de ITE" id="acercaITE">
                {[["Fines Institucionales", "/FinesInstitucionales"],
                  ["Historia", "/Historia"],
                  ["Principios Rectores", "/PrincipiosRectores"],
                  ["Estructura Orgánica", "/EstructuraOrganica"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Consejo General */}
              <NavDropdown title="Consejo General" id="consejoGeneral">
                {[["Integración", "/Integracion"],
                  ["Comisiones Permanentes y Temporales", "/Comisiones"],
                  ["Junta General Ejecutiva", "/JGE"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Acuerdos */}
              <NavDropdown title="Acuerdos" id="acuerdos">
                <NavDropdown.ItemText className="text-secondary">Acuerdos ITE</NavDropdown.ItemText>
                <NavDropdown drop="end" title="Anteriores" id="anterioresITE">
                  <NavDropdown.Item as={Link} to="/AcuerdosAnteriores" onClick={handleLinkClick}>Mostrar todos</NavDropdown.Item>
                  <NavDropdown.Divider />
                  {acuerdosITEYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Acuerdos${year}`} onClick={handleLinkClick}>
                      {year}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/Acuerdos2026" onClick={handleLinkClick}>2026</NavDropdown.Item>

                <NavDropdown.Divider />
                <NavDropdown.ItemText className="text-secondary">Acuerdos INE</NavDropdown.ItemText>
                <NavDropdown drop="end" title="Anteriores" id="anterioresINE">
                  <NavDropdown.Item as={Link} to="/AcuerdosINE" onClick={handleLinkClick}>Mostrar todos</NavDropdown.Item>
                  <NavDropdown.Divider />
                  {acuerdosINEYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/AcuerdosINE${year}`} onClick={handleLinkClick}>
                      {year}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/AcuerdosINE2026" onClick={handleLinkClick}>2026</NavDropdown.Item>
              </NavDropdown>

              {/* Demarcaciones */}
              <NavDropdown title="Demarcaciones" id="demarcaciones">
                <NavDropdown.Item as={Link} to="/Acuerdos" onClick={handleLinkClick}>Acuerdos</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Mapas" onClick={handleLinkClick}>Mapas</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/AcuerdosPJ" onClick={handleLinkClick}>Acuerdos Poder Judicial</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MapasPJ" onClick={handleLinkClick}>Mapas Poder Judicial</NavDropdown.Item>
              </NavDropdown>

              {/* Transparencia */}
              <NavDropdown title="Transparencia" id="transparencia">
                {[["Transparencia", "/Transparencia"],
                  ["Infografías", "/Infografias"],
                  ["Preguntas Frecuentes", "/PreguntasFrecuentes"],
                  ["Datos Abiertos", "/DatosAbiertos"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Comunicación Social */}
              <NavDropdown title="Comunicación Social" id="comunicacionSocial">
                <NavDropdown drop="end" title="Boletines" id="boletinesITE">
                  {boletinesYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Boletines${year}`} onClick={handleLinkClick}>{year}</NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown drop="end" title="Monitoreos" id="monitoreosITE">
                  {monitoreosYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Monitoreos${year}`} onClick={handleLinkClick}>{year}</NavDropdown.Item>
                  ))}
                  <NavDropdown.Item as={Link} to="/MonitoreosPELE2024" onClick={handleLinkClick}>PELE 2024</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/ITEConecta" onClick={handleLinkClick}>ITE Conecta</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/EnCorto" onClick={handleLinkClick}>En Corto</NavDropdown.Item>
              </NavDropdown>

              {/* Cultura Cívica */}
              <NavDropdown title="Cultura Cívica" id="culturaCivica">
                {[["Actividades Lúdicas", "/ActividadesLudicas"],
                  ["Elecciones Escolares", "/EleccionesEscolares"],
                  ["Parlamento Infantil", "/ParlamentoInfantil"],
                  ["Parlamento Juvenil", "/ParlamentoJuvenil"],
                  ["Valores de la Democracia", "/ValoresDemocracia"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>{label}</NavDropdown.Item>
                ))}
                <NavDropdown.Item href="https://itetlax.org.mx/assets/pdf/ccivica/2.pdf" target="_blank" rel="noopener noreferrer">
                  Catálogo de Acciones en Educación Cívica
                </NavDropdown.Item>
              </NavDropdown>

              {/* Archivo */}
              <NavDropdown title="Archivo" id="archivo">
                {[["Instrumentos Normativos", "/InstrumentosNormativos"],
                  ["Planeación Archivística", "/PlaneacionArchivistica"],
                  ["Instrumentos Archivísticos", "/InstrumentosArchivisticos"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>{label}</NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Enlaces adicionales */}
              <Nav.Link as={Link} to="/Licitaciones" onClick={handleLinkClick}>Licitaciones</Nav.Link>
              <Nav.Link href="https://encuesta-satisfaccion.itetlax.org.mx/" target="_blank" rel="noreferrer" style={{ fontSize: '0.85rem', padding: '0.25rem 0.75rem', margin: '0 auto', display: 'block', textAlign: 'center' }}>Encuesta de Satisfacción</Nav.Link>

              </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ====== Estilos modernos con sombra inferior notable ====== */}
      <style>{`
        .modern-navbar {
          background: #a90786 !important;
          /* sombra inferior intensa */
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35) !important;
          transition: all 0.3s ease !important;
        }

        .modern-navbar .nav-link {
          color: #fff !important;
          font-weight: 500 !important;
        }

        .modern-navbar .dropdown-menu {
          background: #fff !important;
          border-radius: 8px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        }

        .modern-navbar .dropdown-menu .dropdown-item {
          color: #555 !important;
        }

        .modern-navbar .dropdown-menu .dropdown-item:hover {
          background-color: rgba(255, 221, 255, 0.2) !important;
          color: #000 !important;
        }

        .modern-navbar .dropdown-menu .dropdown-item-text {
          color: #777 !important;
        }

        .modern-navbar .dropdown-menu .dropdown-toggle {
          color: #000 !important;
        }

        .modern-navbar .navbar-toggler {
          border-color: #fff !important;
        }

        .modern-navbar .navbar-toggler-icon {
          filter: invert(1) !important;
        }
      `}</style>
    </>
  );
};

export default NavbarMenu;